import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectFlow,
  setEditorSaved,
} from "../../../../redux/actions/integrationActions";
import InputWithValidation from "../../../../common/components/InputWithValidation";
import { scrollToTop } from "../../../../env/stage";
import { Label } from "@atlaskit/form";
import { formatDate } from "../../../../common/utils/formatter";
import { Inline, Box } from "@atlaskit/primitives";
import { getUserNameFromAccountId } from "./userInfo";
import UseStaticIP from "./UseStaticIP";
import FlowGroupNameSelect from "../../components/FlowGroupNameSelect";

const FlowDetails = () => {
  const [flowName, setFlowName] = useState("");
  const [flowDescription, setFlowDescription] = useState("");
  const [flowGroupName, setFlowGroupName] = useState("");
  const [updatedByName, setUpdatedByName] = useState("");
  const [createdByName, setCreatedByName] = useState("");
  const flow = useSelector((state) => state.integration.flow);
  const flows = useSelector((state) => state.integration.flows);
  const jiraUser = useSelector((state) => state.jira.jiraUser);
  const dispatch = useDispatch();

  useEffect(() => {
    setFlowName(flow.name);
    setFlowDescription(flow.description);
    setFlowGroupName(flow.groupName || "");
    scrollToTop();

    // Fetch updatedBy user name asynchronously
    const fetchUpdatedByName = async () => {
      if (flow?.metadata?.updatedBy) {
        const name = await getUserNameFromAccountId(
          flow.metadata.updatedBy,
          jiraUser
        );
        setUpdatedByName(name);
      } else {
        setUpdatedByName("");
      }
      if (flow?.metadata?.createdBy) {
        const name = await getUserNameFromAccountId(
          flow?.metadata?.createdBy,
          jiraUser
        );
        setCreatedByName(name);
      } else {
        setCreatedByName("");
      }
    };

    fetchUpdatedByName();
  }, [flow]);

  const changeText = (e) => {
    flow[e.target.name] = e.target.value.substring(0, 250);
    setFlowName(e.target.value);
    dispatch(selectFlow(flow));
    dispatch(setEditorSaved(false));
  };

  const changeDescription = (e) => {
    flow[e.target.name] = e.target.value;
    setFlowDescription(e.target.value);
    dispatch(selectFlow(flow));
    dispatch(setEditorSaved(false));
  };

  const addExistingIntegrationNames = () => {
    return flows.map((flow) => ({
      type: "eq",
      word: flow.name,
      message: "Integration name is not unique, please specify a unique name",
    }));
  };

  const changeGroupName = (value) => {
    flow.groupName = value.trim();
    setFlowGroupName(value);
    dispatch(selectFlow(flow));
    dispatch(setEditorSaved(false));
  };

  return (
    <div className="ihub-edit-flow-details">
      <h4>Integration details</h4>
      <InputWithValidation
        fieldTitle={"Name"}
        fieldName={"name"}
        onChange={changeText}
        inputValue={flowName || ""}
        maxChar={70}
        minChar={4}
        type="textfield"
        stringValidation={addExistingIntegrationNames()}
      />
      <InputWithValidation
        fieldTitle={"Description"}
        fieldName={"description"}
        onChange={changeDescription}
        inputValue={flowDescription || ""}
        maxChar={500}
        type="textarea"
      />
      <br />
      <Label>Group name</Label>
      <FlowGroupNameSelect value={flowGroupName} onChange={changeGroupName} />
      <br />
      <UseStaticIP />
      <br />
      <Inline>
        <Box
          style={{
            display: "grid",
            gridTemplateColumns: "200px auto",
            alignItems: "center",
          }}
        >
          <Label>Created: {formatDate(flow.created)}</Label>
          <Label>{createdByName || ""}</Label>
        </Box>
      </Inline>

      <Inline>
        <Box
          style={{
            display: "grid",
            gridTemplateColumns: "200px auto",
            alignItems: "center",
          }}
        >
          <Label>Updated: {formatDate(flow.updated)}</Label>
          <Label>{updatedByName || ""}</Label>
        </Box>
      </Inline>
      <br></br>
    </div>
  );
};

export default FlowDetails;
